import { render, staticRenderFns } from "./mailLinkmanEdit.vue?vue&type=template&id=2009b6ac&scoped=true&"
import script from "./mailLinkmanEdit.vue?vue&type=script&lang=js&"
export * from "./mailLinkmanEdit.vue?vue&type=script&lang=js&"
import style0 from "./mailLinkmanEdit.vue?vue&type=style&index=0&id=2009b6ac&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2009b6ac",
  null
  
)

export default component.exports